import { Directive } from '@angular/core';

/*
  Generated class for the EmptyState directive.

  See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
  for more info on Angular 2 Directives.
*/
@Directive({
  selector: '[emptyState]'
})
export class EmptyStateDirective {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/empty-state/empty-state.ts